// extracted by mini-css-extract-plugin
export default {"link":"Link_link__j3yA7","barra":"Link_barra__2bkrR","LoadRight":"Link_LoadRight__a-wl3","ExitLeft":"Link_ExitLeft__MzdeI","linkDestacado":"Link_linkDestacado__6ywcZ"};